import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "number-input" }
const _hoisted_2 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "currency-position item-body" }, "$", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["item-label", _ctx.inputClass])
    }, _toDisplayString(_ctx.title), 3),
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["item-label-alt pt-1 mb-2", _ctx.inputClass])
        }, _toDisplayString(_ctx.description), 3))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["input-row col-lg-auto col-md-auto col-sm-auto col-xs-12", _ctx.inputClass])
    }, [
      (_ctx.icon && _ctx.icon.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enteredValue) = $event)),
        class: _normalizeClass([{'ps-2': _ctx.inputPadding, 'input-icon-padding': _ctx.icon && _ctx.icon.length > 0, 'validation-error': _ctx.validationError}, "item-body ins-form-control"]),
        type: "text",
        disabled: _ctx.isDisabled,
        onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validateNumber($event)))
      }, null, 42, _hoisted_5), [
        [
          _vModelText,
          _ctx.enteredValue,
          void 0,
          { number: true }
        ]
      ])
    ], 2),
    (_ctx.validationError)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["mt-1 item-validation-error", _ctx.inputClass])
        }, _toDisplayString(_ctx.validationError), 3))
      : _createCommentVNode("", true)
  ]))
}